import type { CoverLetterDto, CreateCoverLetterDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";

export const createCoverLetter = async (data: CreateCoverLetterDto) => {
  const response = await axios.post<
    CoverLetterDto,
    AxiosResponse<CoverLetterDto>,
    CreateCoverLetterDto
  >("/cover-letter", data);

  return response.data;
};

export const useCreateCoverLetter = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: createCoverLetterFn,
  } = useMutation({
    mutationFn: createCoverLetter,
    onSuccess: (data) => {
      queryClient.setQueryData<CoverLetterDto>(["cover-letter", { id: data.id }], data);

      queryClient.setQueryData<CoverLetterDto[]>(["cover-letters"], (cache) => {
        if (!cache) return [data];
        return [...cache, data];
      });
    },
  });

  return { createCoverLetter: createCoverLetterFn, loading, error };
};
